import script from "./ScoresSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoresSummary.vue?vue&type=script&setup=true&lang=js"

import "./ScoresSummary.vue?vue&type=style&index=0&id=34522a5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34522a5e"]])

export default __exports__